import { NgComponentOutlet } from '@angular/common';
import { Component, computed, input, Type } from '@angular/core';
import { EmployeeLinkPipe } from '@web/shared/pipes/employee-link.pipe';
import { isEmpty } from 'class-validator';
import { EmployeeCodeTagComponent } from '../../employee-code-tag.component';
import { OwnerCompanyCodeTagComponent } from '../../owner-company-code-tag.component';
import { SupplierCodeTagComponent } from '../../supplier-code-tag.component';
import { SearchEmployeeEntry } from '../interfaces/search-employee-entry.interface';
import { DetailItem, SearchItemBaseComponent } from './search-item-base.component';

@Component({
  selector: 'app-search-employee-item',
  imports: [EmployeeCodeTagComponent, EmployeeLinkPipe, SearchItemBaseComponent, NgComponentOutlet],
  template: `
    @let _item = item();

    <app-search-item-base
      icon="pi pi-id-card"
      color="text-soe-orchid-purple"
      [detailRouterLink]="_item | employeeLink"
      [detailItems]="detailItems()"
    >
      <ng-template #title>
        <div [innerHTML]="_item.name"></div>
      </ng-template>

      <ng-template #codeTag>
        <div class="flex items-center gap-2">
          <app-employee-code-tag [employee]="_item" [clickable]="false" />
          @let companyTag = companyTagComponents[_item.relatedTo.aggregate];
          <ng-container *ngComponentOutlet="companyTag[0]; inputs: companyTag[1](_item)"> </ng-container>
        </div>
      </ng-template>
    </app-search-item-base>
  `,
})
export class SearchEmployeeItemComponent {
  readonly item = input.required<SearchEmployeeEntry>();
  readonly companyTagComponents: Record<
    SearchEmployeeEntry['relatedTo']['aggregate'],
    [Type<unknown>, (item: SearchEmployeeEntry) => Record<string, unknown>]
  > = {
    Supplier: [SupplierCodeTagComponent, (item) => ({ supplier: item.relatedTo, clickable: true })],
    OwnerCompany: [OwnerCompanyCodeTagComponent, () => ({ clickable: true })],
  };

  readonly detailItems = computed<DetailItem[]>(() => {
    const item = this.item();

    return [
      {
        icon: 'pi pi-map-marker',
        content: `${item.address} ${item.streetNumber}, ${item.zipCode} ${item.city}, ${item.state}, ${item.country}`,
        isHtml: true,
      },
      {
        icon: 'pi pi-envelope',
        content: item.email,
        isHtml: true,
      },
      {
        icon: 'pi pi-phone',
        content: item.phoneNumber,
        isHtml: true,
      },
    ].filter((v) => !isEmpty(v.content));
  });
}
